module.exports = __webpack_public_path__ + "static/media/2.27d050ce.png";